import React from 'react';
import { useTranslation } from 'react-i18next';
import { EXPERIMENT_TYPES, EXPERIMENT_STATUSES, PROVIDER_OPTIONS } from '../../types/experiment';

interface ExperimentFiltersProps {
    selectedType: string;
    selectedStatus: string;
    selectedProvider: string;
    selectedTag: string;
    availableTags: string[];
    onTypeChange: (type: string) => void;
    onStatusChange: (status: string) => void;
    onProviderChange: (provider: string) => void;
    onTagChange: (tag: string) => void;
    onClearFilters: () => void;
}

const ExperimentFilters: React.FC<ExperimentFiltersProps> = ({
    selectedType,
    selectedStatus,
    selectedProvider,
    selectedTag,
    availableTags,
    onTypeChange,
    onStatusChange,
    onProviderChange,
    onTagChange,
    onClearFilters
}) => {
    const { t } = useTranslation();

    const hasActiveFilters = selectedType || selectedStatus || selectedProvider || selectedTag;

    return (
        <div className="experiment-filters">
            <div className="filter-group">
                <label className="filter-label">{t('experiments.filters.type')}</label>
                <select
                    className="filter-select"
                    value={selectedType}
                    onChange={(e) => onTypeChange(e.target.value)}
                >
                    <option value="">{t('experiments.filters.allTypes')}</option>
                    {EXPERIMENT_TYPES.map((type) => (
                        <option key={type} value={type}>
                            {type}
                        </option>
                    ))}
                </select>
            </div>

            <div className="filter-group">
                <label className="filter-label">{t('experiments.filters.status')}</label>
                <select
                    className="filter-select"
                    value={selectedStatus}
                    onChange={(e) => onStatusChange(e.target.value)}
                >
                    <option value="">{t('experiments.filters.allStatuses')}</option>
                    {EXPERIMENT_STATUSES.map((status) => (
                        <option key={status} value={status}>
                            {t(`experiments.status.${status}`) || status}
                        </option>
                    ))}
                </select>
            </div>

            <div className="filter-group">
                <label className="filter-label">{t('experiments.filters.provider')}</label>
                <select
                    className="filter-select"
                    value={selectedProvider}
                    onChange={(e) => onProviderChange(e.target.value)}
                >
                    <option value="">{t('experiments.filters.allProviders')}</option>
                    {PROVIDER_OPTIONS.map((provider) => (
                        <option key={provider} value={provider}>
                            {provider}
                        </option>
                    ))}
                </select>
            </div>

            <div className="filter-group">
                <label className="filter-label">{t('experiments.filters.tag')}</label>
                <select
                    className="filter-select"
                    value={selectedTag}
                    onChange={(e) => onTagChange(e.target.value)}
                >
                    <option value="">{t('experiments.filters.allTags')}</option>
                    {availableTags.map((tag) => (
                        <option key={tag} value={tag}>
                            {tag}
                        </option>
                    ))}
                </select>
            </div>

            {hasActiveFilters && (
                <button
                    className="filter-clear-btn"
                    onClick={onClearFilters}
                    title={t('experiments.filters.clearAll')}
                >
                    <span className="material-icons">clear</span>
                    {t('experiments.filters.clearAll')}
                </button>
            )}
        </div>
    );
};

export default ExperimentFilters;
